import { useHomeV2 } from "@flags";
import TasksLegacy from "./TasksLegacy";
import TasksV2 from "./TasksV2";

// The Today's tasks redesign (tabs, working sets) ships behind the Smart Note V2 flag.
const Tasks = () => (useHomeV2() ? <TasksV2 /> : <TasksLegacy />);

export default Tasks;
